import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { HeadingModule } from '../heading/heading.module';
import { CodeInputComponent } from './code-input.component';

@NgModule({
  declarations: [CodeInputComponent],
  exports: [CodeInputComponent],
  imports: [CommonModule, HeadingModule, I18nModule],
})
export class CodeInputModule {}
export { CodeInputComponent } from './code-input.component';
